import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
export const AuthRouter = ({ children }) => {
  //check user authenticate and redirect on appropriate page based on user role
  const { user } = useSelector((state) => state?.Auth);
  const token = localStorage.getItem('token');
  return token && user?.role === 'editor' && user?.is_editor === false ? <Navigate to="/programs" /> : token && user?.role  === 'doctor' || user?.is_editor === true ||user?.role === 'researcher'|| user?.role === 'admin' ? <Navigate to="/dashboard" /> : children;
};
